export const MAP_LAYER_COLORS = {
  // Three families, so the map reads at a glance:
  //   PP red   — deals. The four active stages share one red on purpose; the
  //              letter inside the pin still tells them apart. Stages that are
  //              off by default are muted variants of the same red so they
  //              read as the same family, not active.
  //   Black    — sale comps.
  //   Grey     — lease comps.
  // Outreach keeps its own colour: it is a parallel track, not a stage.
  screening:   "#e93529",
  underwriting:"#e93529",
  loi:         "#e93529",
  contract:    "#e93529",

  tracking:    "#f4a6a0",
  pass:        "#b0a3a1",
  lost:        "#a5241b",
  dead:        "#5f5250",

  // Outreach was teal, which is not in the palette. Collapsing it to grey put
  // it on exactly the same colour as a lease comp pin, which is the one thing
  // this layer must not be - so it takes the gold the rest of the app uses for
  // "in flight", distinct from the deal reds, the comp black and the comp grey.
  sourcing:    "#c8922f",
  // Broker LOIs (the Outreach section): purple, apart from the deal reds,
  // the Sourcing gold and the comp black/grey.
  outreach:    "#9b6bcc",

  comp_sale:   "#333333",
  // Brand grey (#d8d8d8) is a border colour and vanishes as a pin against
  // both light tiles and satellite, so pins use a readable mid grey.
  comp_lease:  "#8a8a8a",
};

export const MAP_LAYER_LABELS = {
  tracking:    "Tracking",
  sourcing:    "Sourcing",
  outreach:    "Outreach",
  screening:   "Screening",
  underwriting:"Underwriting",
  loi:         "LOI Submitted",
  contract:    "In Diligence",
  pass:        "Passed",
  lost:        "Lost",
  dead:        "Dead",
  comp_sale:   "Sale Comp",
  comp_lease:  "Lease Comp",
};

export const MAP_LAYER_LETTERS = {
  tracking: "T", sourcing: "R", outreach: "O", screening: "S", underwriting: "U", loi: "L", contract: "D", pass: "P", lost: "X", dead: "K", comp_sale: "$", comp_lease: "\u00A2",
};

// Pre-geocoded sub-address coordinates for multi-address deals (Google rooftop)
export const SUB_ADDR_CACHE = {
  "620 douglas ave altamonte springs, fl 32714": [28.67120509999999,-81.3910367],
  "337 s northlake blvd altamonte springs, fl 32701": [28.6554176,-81.38587849999999],
  "317 s northlake blvd altamonte springs, fl 32701": [28.6561903,-81.3857532],
  "309 altamonte commerce blvd altamonte springs, fl 32714": [28.6740535,-81.393301],
  "658 douglas ave altamonte springs, fl 32714": [28.6741255,-81.39086540000001],
  "217 altamonte commerce blvd altamonte springs, fl 32714": [28.67412749999999,-81.39156349999999],
  "223 altamonte commerce blvd altamonte springs, fl 32714": [28.6741218,-81.3923756],
  "251 altamonte commerce blvd altamonte springs, fl 32714": [28.6738435,-81.39273349999999],
  "311 altamonte commerce blvd altamonte springs, fl 32714": [28.6741146,-81.3939156],
  "4401 nw 74th ave miami, fl 33166": [25.8145215,-80.3171946],
  "4400 nw 72 ave miami, fl 33166": [25.814531,-80.3137725],
  "2900 nw 72 ave miami, fl 33122": [25.800534,-80.3136],
  "2800 nw 72 ave miami, fl 33122": [25.799467,-80.31343389999999],
  "2600 nw 72 ave miami, fl 33122": [25.7984982,-80.3134056],
  "5100 vivian place, tampa, fl": [27.9240718,-82.3987145],
  "2414 gelman place, tampa, fl": [27.924383,-82.39834630000001],
  "5300 east adamo drive, tampa, fl": [27.9542835,-82.39577539999999],
  "5302 east adamo drive, tampa, fl": [27.9533388,-82.39538060000001],
  "120 country view drive, frisco, texas": [33.1268361,-96.8701523],
  "125 country view drive, lewisville, texas": [33.0463292,-96.9941903],
  "1750 briercroft court, mesquite, texas": [32.9353305,-96.92868150000001],
  "2828 interstate 30, plano, texas": [32.8151833,-96.6419147],
  "535 talbert drive, roanoke, texas": [33.0093995,-96.7790546],
  "760 east main street, roanoke, texas": [32.9658781,-97.2487712],
  "4505 24th street east, bradenton, florida": [27.4598935,-82.5311596],
  "7510 ardmore street, houston, texas": [29.6879985,-95.38246889999999],
  "21207 clay road, park row, texas": [29.8312911,-95.74331049999999],
  "21211 clay road, park row, texas": [29.831312,-95.74366649999999],
  "21217 clay road, park row, texas": [29.8305934,-95.7433776],
  "21221 clay road, park row, texas": [29.8312698,-95.7440639],
  "21323 clay road, park row, texas": [29.831672,-95.7449944],
  "21331 clay road, park row, texas": [29.8316705,-95.7450722],
  "220 accolade avenue, saint johns, florida": [30.0901673,-81.46889080000001],
  "511 northeast 32nd street, pompano beach, florida": [26.2703532,-80.1184483],
  "3350 davie road, davie, florida": [26.0818387,-80.2271458],
  "3360 davie road, davie, florida": [26.0803747,-80.22618539999999],
  "3370 davie road, davie, florida": [26.0789071,-80.2254023],
  "3380 davie road, davie, florida": [26.080128,-80.2304903],
  "3410 davie road, davie, florida": [26.07854,-80.22761899999999],
  "3430 davie road, davie, florida": [26.0786775,-80.2288523],
  "1911 old denton road, carrollton, texas": [32.9655544,-96.9142507],
  "4300 sunbelt drive, carrollton, texas": [32.9767016,-96.836733],
  "4755 110th avenue north, pinellas park, florida": [27.8722224,-82.6983241],
  "4757 110th terrace north, st. petersburg, florida": [27.8726649,-82.6983092],
  "4770 110th avenue north, st. petersburg, florida": [27.8717183,-82.69849470000001],
  "4980 73rd avenue north, st. petersburg, florida": [27.8389166,-82.6468591],
  "5520 64th way north, st. petersburg, florida": [27.8217147,-82.7268222],
  "3111 fortune way, wellington, florida": [26.635746,-80.227492],
  "7551 south sam houston parkway east, houston, texas": [29.6020722,-95.2913176],
  "7561 south sam houston parkway east, houston, texas": [29.6038711,-95.2914203],
  "5100 causeway boulevard, tampa, florida": [27.924076,-82.39880699999999],
  "5100 vivian place, tampa, florida": [27.9240718,-82.3987145],
  "5300 east adamo drive, tampa, florida": [27.9542835,-82.39577539999999],
  "5302 east adamo drive, tampa, florida": [27.9533388,-82.39538060000001],
  "3999 northwest 19th street, lauderdale lakes, florida": [26.150862,-80.20188879999999],
  "850 east arapaho road, richardson, texas": [32.960236,-96.71002610000001],
};

export function lookupSubAddr(addr) {
  const key = addr.toLowerCase().trim();
  const c = SUB_ADDR_CACHE[key];
  if (c) return { lat: c[0], lng: c[1] };
  // geo2_, not geo_: entries under the old key were geocoded US-wide with no
  // state check, and are deliberately not trusted. See MapView's loader.
  try { const s = localStorage.getItem("geo2_" + key); if (s) { const p = JSON.parse(s); if (p.lat) return p; } } catch {}
  return null;
}

export const MAP_QUICK_CHIPS = [
  "Properties with LOI",
  "Pipeline value",
  "Texas properties",
  "Parcel lookup",
  "Draft an LOI",
  "Show in Diligence",
  "Doral properties",
  "Reset the map",
];

export function normalizeMapStage(rawStage, dealFlow) {
  // A broker LOI (Outreach section) is drawn as Outreach whatever its stage.
  if (dealFlow === "outreach") return "outreach";
  const s = (rawStage || "").toLowerCase().trim();
  if (s === "tracking" || s === "wishlist" || s === "monitoring") return "tracking";
  if (s === "sourcing" || s === "outreach") return "sourcing";
  if (s === "screening") return "screening";
  if (s === "underwriting" || s === "pursuing") return "underwriting";
  if (s === "loi submitted" || s === "under loi" || s === "loi" || s === "speaking w/ seller") return "loi";
  if (s === "in diligence" || s === "contract") return "contract";
  // Deals raised by the LOI Sender are outreach. Legacy rows still carrying
  // the old "Unsolicited Offer" value fold in here too.
  if (s === "unsolicited offer" || s === "unsolicited") return "sourcing";
  if (s === "pass" || s === "passed") return "pass";
  if (s === "lost") return "lost";
  if (s === "dead") return "dead";
  return "screening";
}

// Deal stages considered active — everything the Pipeline actually works.
export const ACTIVE_STAGE_KEYS = ["screening", "underwriting", "loi", "contract"];

// Stages that render muted: same red family, visibly not active.
export const MUTED_STAGE_KEYS = ["tracking", "pass", "lost", "dead"];
